import Nullstack from 'nullstack';
export default function IconUfo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ufo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 2.367 -4.48 4.276 -10 4.276s-10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724"
  }), "   ", Nullstack.element("path", {
    d: "M7 9c0 1.105 2.239 2 5 2s5 -.895 5 -2v-.035c0 -2.742 -2.239 -4.965 -5 -4.965s-5 2.223 -5 4.965v.035"
  }), "   ", Nullstack.element("path", {
    d: "M15 17l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 17l-1.5 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 14h.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 13h.01"
  }), "   ", Nullstack.element("path", {
    d: "M17 13h.01"
  }), " ");
}